import * as React from "react";
import { alpha, styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import { FormControlLabel, Typography } from "@mui/material";

/**
 * Input of custom switch type based on Material UI library
 * @param disabled true|false
 * @param onChange event to change state
 * @param checked swtich state
 */

export const EGSwitch = ({
  disabled = false,
  onChange,
  checked,
  label,
  labelPlacement = "start",
  sx = {},
  ...props
}) => {
  // Style customization
  const MainSwitch = styled(Switch)(({ theme }) => ({
    // Switch base
    "& .MuiSwitch-switchBase": {
      "&:hover": {
        backgroundColor: alpha(theme.palette.primary.main, 0.1),
      },
      // Switch disabled
      "&.Mui-disabled": {
        // Custom border and background color
        "& .MuiSwitch-thumb": {
          border: `1px solid ${theme.palette.blueGray100.main}`,
          backgroundColor: theme.palette.common.white,
        },
        // Slide track color
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.blueGray700.main,
        },
      },
      // Switch checked
      "&.Mui-checked": {
        // Custom border and background color
        "& .MuiSwitch-thumb": {
          border: `1px solid ${theme.palette.primary.main}`,
          backgroundColor: theme.palette.common.white,
          boxShadow: `0 0 2px 3px ${alpha(theme.palette.primary.light, 0.3)}`,
        },
        // Slide track color
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.success.main,
          opacity: 1,
        },
      },
      // Combination of checked and disabled styles
      "&.Mui-checked.Mui-disabled": {
        // Custom border and background color
        "& .MuiSwitch-thumb": {
          border: `2px solid ${theme.palette.blueGray100.main}`,
          backgroundColor: theme.palette.common.white,
          boxShadow: `0px 0 2px 3px ${alpha(
            theme.palette.blueGray100.main,
            0.4
          )}`,
        },
        // Slide track color
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.blueGray100.main,
        },
      },
    },
    // Swtich circle (default)
    "& .MuiSwitch-thumb": {
      border: `1px solid ${theme.palette.ethicsBlue.main}`,
    },
    //Switch sliding track (default)
    "& .MuiSwitch-track": {
      backgroundColor: theme.palette.blueGray500.main,
    },
  }));

  // Handles the onChange event of the switch
  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <FormControlLabel
      control={
        <MainSwitch
          disabled={disabled}
          checked={checked}
          onChange={handleChange}
          {...props}
        />
      }
      label={label ? <Typography variant="subtitle1">{label}</Typography> : null}
      labelPlacement={labelPlacement}
      sx={sx}
    />
  );
};
